import { ReactElement, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAPIError from '../../hooks/apiError.context';
import useAuth from '../../hooks/auth.hook';

function RequireAuth({ children }: { children: ReactElement }) {
  const auth = useAuth();
  const location = useLocation();
  const { addError } = useAPIError();

  useEffect(() => {
    const refreshToken = async () => {
      await auth.refresh();
    };

    if (auth.isLoggedIn() && !auth.isAccessTokenExpired()) {
      refreshToken();
    }
  });

  if (!auth.isLoggedIn()) {
    addError('Su sesión ha caducado. Vuelva a iniciar sesión', 'danger');
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAuth;
